import template from './courseHeader.partial.html';
import './courseHeader.scss';

const HELP_IDS_CONSTANTS = {
  // 1
  imposingTheStructure: 'imposing-the-structure',
  pickingOutThePoints: 'cementing-the-rules',
  cementingTheRules: 'picking-out-the-points',
  graspingTheMessage: 'grasping-the-message',
  // 2
  ideasFitTogether: 'ideas-fit-together',
  creatingQuestion: 'creating-question',
  // 3
  deductiveReasoning: 'deductive-reasoning',
  summarizingDeductive: 'summarizing-deductive',
  unearthingEmbeddedArguments: 'unearthing-embedded-arguments',
  inductiveReasoning: 'inductive-reasoning',
  identifyingInductivePoints: 'identifying-inductive-points',
  inductionFromDeduction: 'induction-from-deduction',
  deductionToInduction: 'deduction-to-induction',
  avoidingDeductiveArguments: 'avoiding-deductive-arguments',
  // 4
  practiceInSeeing: 'practice-in-seeing',
  findingReadersQuestion: 'finding-readers-question',
  spottingSCQ: 'spotting-scq',
  applyingSCQProcess: 'applying-scq-process',
  practiceInSeeing3: 'practice-in-seeing-3',
  // 5
  defineProblem: 'define-problem',
  practiceDefiningProblem: 'practice-defining-problem',
  definingMoreComplexProblems: 'defining-more-complex-problems',
  writingAGoodProposal: 'writing-a-good-proposal'
}

export default (authService, $state) => {

    return {
        scope: {
            bg: '@',
            hideLogo: '@'
        },
        restrict: 'E',
        replace: true,
        transclude: true,
        link: function (scope) {
          scope.logout = () => {
            authService.logOut();
          }

          scope.showTestDrivePopup = false;
          scope.togglePopup = () => {
            scope.showTestDrivePopup = !scope.showTestDrivePopup;
          }

          scope.openOption = null;
          scope.showNavigationPanel = false;
          scope.toogleNavigationPanel = (option) => {
            if (scope.openOption !== option && scope.showNavigationPanel) {
              scope.openOption = option
            } else {
              scope.openOption = option;
              scope.showNavigationPanel = !scope.showNavigationPanel;
            }
          }

          scope.handleUrlChange = (option) => {
            if (scope.openOption === 'nav') {
              $state.go(`course.${option}`)
            } else {
              if ($state.current.name === 'site.help') {
                document.getElementById(HELP_IDS_CONSTANTS[option]).scrollIntoView({
                  behavior: "smooth"
                });
              } else {
                $state.go('site.help', {sectionId: HELP_IDS_CONSTANTS[option], prevRoute: $state.current.name})
              }
            }
          }

          scope.getActiveSection = (routeName) => {
            return routeName === $state.current.name
          }

          scope.bodyOpen = false;
          scope.toggleNavBar = () => {
            scope.bodyOpen = !scope.bodyOpen
            scope.showNavigationPanel = false;
          }

          scope.$watch('showNavigationPanel', () => {
            if (scope.showNavigationPanel) {
              scope.sectionsList = angular.element('.course__nav-panel__sections-wrapper');
              scope.maxScroll = scope.sectionsList[0].offsetHeight - 90;

              scope.sectionsList.bind('scroll', (e) => {
                scope.currentScroll = e.delegateTarget.scrollTop;
              });

              const activeElement = scope.sectionsList.find('.active')[0];
              const activeElementOffsetTop = activeElement
                ? activeElement.offsetTop - scope.sectionsList[0].offsetTop - 60
                : 0;

              switch (true) {
                case activeElementOffsetTop <= 0:
                  scope.sectionsList.scrollTop(0);
                  break;
                case activeElementOffsetTop >= scope.maxScroll:
                  scope.sectionsList.scrollTop(scope.maxScroll);
                  break;
                default:
                  scope.sectionsList.scrollTop(activeElementOffsetTop);
              }
              }
          })

          scope.currentScroll = 0;
          scope.scrollTo = (direction) => {
            if (direction === 'up') {
              const newScroll = scope.currentScroll - 15
              if (newScroll <= 0) {
                scope.sectionsList.scrollTop(0)
              } else {
                scope.sectionsList.scrollTop(newScroll)
              }
            } else if (direction === 'down') {
              const newScroll = scope.currentScroll + 15
              if (newScroll >= scope.maxScroll) {
                scope.sectionsList.scrollTop(scope.maxScroll)
              } else {
                scope.sectionsList.scrollTop(newScroll)
              }
            }
          }

        },
        template
    };

};



// WEBPACK FOOTER //
// ./client/app/blocks/courseHeader/courseHeader.directive.js